import { USER_ROLES } from "@nlc/shared-types";
import { useQuery } from "@tanstack/react-query";

import { useRoleAccess } from "@/features/auth/permissions/useRoleAccess";
import { uploadingSessionKeys } from "@/hooks/queryKeys";

import { getUploadingPolicy } from "../api/confidence-checker.api";

interface UseUploadingPolicyReturn {
  isConfidenceChecker: boolean;
  isLoading: boolean;
}

export function useUploadingPolicy(
  requestId: number | undefined,
): UseUploadingPolicyReturn {
  const { hasRole } = useRoleAccess();
  const isEligible = hasRole([USER_ROLES.DESIGNER, USER_ROLES.TEAM_LEADER]);
  const isEnabled =
    isEligible && requestId !== undefined && Number(requestId) > 0;

  const { data, isLoading } = useQuery({
    enabled: isEnabled,
    queryFn: () => getUploadingPolicy(Number(requestId)),
    queryKey: uploadingSessionKeys.policy(Number(requestId ?? 0)),
  });

  return {
    isConfidenceChecker: data?.policy === "confidence-checker",
    isLoading: isEnabled && isLoading,
  };
}
